export const bulkSendToSAPOptions = [
  { label: 'Send to SAP', value: 'sendToSap', color: '' }
]
